(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const submitBtn = document.getElementById('submitBtn');
  const hiddenSubbmit = document.getElementById('submit'); 
  submitBtn.addEventListener('click', function(e) {  
  // 1. Stop default and add loading class 
    e.preventDefault();
    e.stopPropagation();
    submitBtn.classList.add('loading'); 
    // 2. Check if the input was checked
    const checkInput = document.getElementById('CartTerms'); 
    // 2.a Submit form if so 
    if (checkInput) {
      if (checkInput.checked === true) {
        hiddenSubbmit.click(); 
        return true; 
      }
    } else {
      hiddenSubbmit.click(); 
      return true; 
    }
    // 3. If not - show alert 
    submitBtn.classList.remove('loading')
    alert(theme.strings.cartTermsConfirmation);
    }
  );

  } catch(e) { console.error(e); }
})();
})();
